const OKTA_URL = process.env.OKTA_BASE_URL;

export default {
  redirectToOkta: () => {
    const relayState = encodeURIComponent(window.location.pathname + window.location.search);
    window.location = `${OKTA_URL}?RelayState=${relayState}`;
  }
};
